/**
 * Relay Configuration
 */

import { Environment, Network, RecordSource, Store } from 'relay-runtime';

// Define a function that fetches the results of an operation (query/mutation/etc)
// and returns its results as a Promise:
function fetchQuery(
  operation,
  variables,
  cacheConfig,
  uploadables,
) {
  return fetch('/graphql', {
    credentials: 'include',
    method: 'POST',
    headers: new Headers({
      // Add authentication and other headers here
      'content-type': 'application/json',
    }),
    body: JSON.stringify({
      query: operation.text, // GraphQL text from input
      variables,
    }),
  }).then((response) => {
    if (response.status === 503) {
      return response.text()
        .then((text) => {
          document.body.innerHTML = text;
        });
    }
    return response.json();
  });
}

// Create a network layer from the fetch function
const network = Network.create(fetchQuery);

export const environment = new Environment({
  network,
  store: new Store(new RecordSource()),
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/relay/index.ts